export default "__VITE_ASSET__DJfkLCKz__"